<template>
  <div class="main" :class="theme == 2 ? 'bg000' : 'bgfff'">
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <ul
        v-if="list.length > 0"
        class="list"
        style="padding: 0.3rem 0; padding-bottom: 2rem"
      >
        <van-list v-model="loading" :finished="finished" @load="onLoad">
          <li v-for="(item, i) in list" :key="i" class="card isTrue">
            <div class="card-top">
              <div class="left">
                <p v-if="item.MsgType == 1">
                  <span style="font-weight: 500">￥</span
                  ><span style="font-size: 0.84rem" class="faDINCondensedC">{{
                    item.Msg
                  }}</span>
                </p>
                <p v-else>
                  <span style="font-size: 0.84rem" class="faDINCondensedC">{{
                    item.Msg
                  }}</span
                  ><span style="font-weight: 500">折</span>
                </p>
                <p>{{ item.discountCondition }}</p>
              </div>

              <div class="right1">
                <p>{{ item.title | ellipsis }}</p>
                <p class="time">
                  {{ item.startDate.replace(/-/g, ".") }}-{{
                    item.endDate.replace(/-/g, ".")
                  }}
                </p>
              </div>
            </div>
            <div class="card-bottom">
              <span>▪ 用于订单 {{ item.orderNo }}</span>
              <span> {{ item.productName }}（{{ item.dateType }}）</span>
            </div>
          </li>
        </van-list>
      </ul>
      <wushuju v-else :theme="theme"></wushuju>
    </van-pull-refresh>
  </div>
</template>

<script>
import { Toast, Icon, List, PullRefresh } from "vant";
import wushuju from "@/components/wushuju";
import api from "@/api/mall";
import {
  connectWebViewJavascriptBridge,
  getBrowserUserAgent,
} from "@/utils/utility";
import store from "@/store";
var userAgent = getBrowserUserAgent();
var dsBridge = require("dsbridge");
export default {
  components: {
    [Toast.name]: Toast,
    [Icon.name]: Icon,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,

    wushuju,
  },
  props: {
    price: Number,
    theme: Number,
  },
  data() {
    return {
      nonuse: false,
      list: [],
      total: 0,
      active: null,
      loading: false,
      finished: true,
      isLoading: false,
      page: 1,
    };
  },
  filters: {
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 15) {
        return value.slice(0, 15) + "...";
      }
      return value;
    },
  },
  created() {
    if (sessionStorage.getItem("theme") == 2) {
      this.theme = 2;
    } else {
      this.theme = 1;
    }
    this.getList();
  },
  mounted() {
    var that = this;
    if (userAgent.android) {
      dsBridge.register("changeTheme", function (responseData) {
        responseData = JSON.parse(responseData);
        that.theme = responseData;
        that.$emit("changeTheme", that.theme);
        sessionStorage.setItem("theme", responseData);
      });
    } else {
      connectWebViewJavascriptBridge((bridge) => {
        var that = this;
        window.WebViewJavascriptBridge.registerHandler(
          "changeTheme",
          function (responseData) {
            responseData = JSON.parse(responseData);
            that.theme = responseData;
            that.$emit("changeTheme", that.theme);
            sessionStorage.setItem("theme", responseData);
          }
        );
      });
    }
  },
  methods: {
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      setTimeout(() => {
        this.page++;

        // 加载状态结束
        // console.log(this.page);
        this.loading = false;
        this.getList();

        // 数据全部加载完成
      }, 1000);
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        this.page = 1;
        this.getList();
      }, 1000);
    },
    getList() {
      let params = {
        state: 2,
        page: this.page,
        pageSize: 10,
      };
      api.getUserDiscountCouponList(params).then((res) => {
        if (res.code == 200) {
          this.total = res.data.total;
          var list = [];
          res.data.records.forEach((p) => {
            if (p.discountMsg.indexOf("￥") != -1) {
              p.Msg = p.discountMsg.replace(/￥/g, "");
              p.MsgType = 1;
            } else {
              p.Msg = p.discountMsg.replace(/折/g, "");
              p.MsgType = 2;
            }
            list.push(p);
          });
          if (this.page == 1) {
            this.list = [];
          }
          this.list = this.list.concat(list);
          if (this.list.length >= this.total) {
            this.finished = true;
            this.title = "没有更多了";
          } else {
            this.finished = false;
            this.title = "";
          }
        }
      });
    },
  },
};
</script>


<style lang="less" scoped>
.faDINCondensedC {
  font-family: "DINCondensedC";
}
.main {
  // min-height: calc(100vh - 66px);
}
.isTrue {
  background: url(../assets/bj11.png) no-repeat;
  background-size: 100% 100%;
}
.isFalse {
  background: url(../assets/bj222333.png) no-repeat;
  background-size: 100% 100%;
}
.card {
  //   width: 6.88rem;
  position: relative;
  height: 2.9rem;
  margin: 0 0.28rem 0.28rem 0.28rem;
  // display: flex;
  // align-items: center;
  .card-top {
    display: flex;
    align-items: center;
  }
  .left {
    width: 2.24rem;
    height: 1.7rem;
    padding-top: 0.3rem;
    color: #fff;
    text-align: center;
  }
  .right {
    width: 3.9rem;
    height: 2rem;
    margin-right: 0.11rem;

    text-shadow: 0px 0.02rem 0.11rem #f3f3fa;
    color: #5d667a;
    p:nth-child(1) {
      font-size: 0.38rem;
      font-weight: 600;
      padding-left: 0.35rem;
      line-height: 0.53rem;
      padding-top: 0.25rem;
      color: #333;
    }
    p:nth-child(2) {
      font-size: 0.3rem;
      font-weight: 400;
      padding-left: 0.35rem;
      line-height: 0.42rem;
      padding-top: 0.04rem;
      color: #333;
    }
    p:nth-child(3) {
      font-size: 0.26rem;
      padding-left: 0.35rem;
      font-weight: 400;
      padding-top: 0.18rem;
      color: #999;
    }
  }
  .right1 {
    width: 3.9rem;
    height: 2rem;
    margin-right: 0.11rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-shadow: 0px 0.02rem 0.11rem #f3f3fa;
    color: #5d667a;
    p:nth-child(1) {
      font-size: 0.36rem;
      font-weight: 500;
      padding-left: 0.35rem;
      line-height: 0.53rem;
      color: #333;
    }

    p:nth-child(2) {
      font-size: 0.26rem;
      padding-left: 0.35rem;
      font-weight: 400;
      padding-top: 0.08rem;
      color: #999;
    }
  }
  .card-bottom {
    padding: 0.34rem 0.25rem;
    display: flex;
    font-size: 0.26rem;
    color: #9097a5;
    justify-content: space-between;
  }
}
.list {
  background: #f3f3fa;
}
.iconType {
  width: 1.36rem;
  height: 1.39rem;
  position: absolute;
  right: -0.07rem;
  top: 0.25rem;
  img {
    width: 100%;
  }
}
.bg000 {
  background: #000;
  .isTrue {
    background: url(../assets/bj2.png) no-repeat;
    background-size: 100% 100%;
  }
  .isFalse {
    background: url(../assets/bj232.png) no-repeat;
    background-size: 100% 100%;
  }
  .list {
    background: #000;
  }
  .right1 {
    text-shadow: 0px 0 0 #f3f3fa;
    color: #f0f1f5 !important ;
    p:nth-child(1) {
      color: #f0f1f5;
    }

    p:nth-child(3) {
      color: #a7b0c5;
    }
    .time {
      color: #a7b0c5 !important ;
    }
  }
  .card-bottom {
    color: #a7b0c5;
  }
}
.bgfff {
  background: #f3f3fa;
}
</style>